import { useState, useEffect } from "react";
import { Flex } from "@radix-ui/themes";
import { MenuItem } from "components";
import { Outlet, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useProfileContext } from "context";
import { MapPinIcon, UserGroupIcon, BuildingOffice2Icon, CalendarDateRangeIcon } from "@heroicons/react/24/outline";

export function OrganisationLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile } = useProfileContext();
  const [organisationName, setOrganisationName] = useState(userProfile.organisation_name);

  // Helper function to get menu state from path
  const getMenuStateFromPath = (path) => {
    if (path.includes("/organisation/locations")) return "locations";
    if (path.includes("/organisation/team")) return "team";
    if (path.includes("/organisation/details")) return "details";
    if (path.includes("/organisation/billing")) return "billing";
    // if (path.includes("/organisation/brands")) return "brands";
    return "locations"; // default path
  };

  // State to manage menu selection
  const [wifiMenuSelection, setWifiMenuSelection] = useState(getMenuStateFromPath(location.pathname));

  // Function to handle menu selection
  const handleWifiMenuSelection = (flag) => {
    setWifiMenuSelection(flag);
    navigate(flag);
  };

  // Update menu selection on path change
  useEffect(() => {
    setWifiMenuSelection(getMenuStateFromPath(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    setOrganisationName(userProfile.organisation_name);
  }, [userProfile.organisation_name]);

  return (
    <Flex className="organisation-layout" direction="column" gap="1" height="100%" 
      style={{ alignSelf: "stretch", alignItems: "flex-start", flex: "1 0 0" }}>
      {/* Main content */}
      <Flex className="main-content-container" height="100%" gap="8" p="5"
        style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start" }}>
        <Flex className="main-content-sidebar-menu" width="144px" direction="column" gap="1" height="100%" style={{ alignItems: "flex-start" }}>
          <MenuItem
            flag="locations"
            state={wifiMenuSelection}
            onClick={handleWifiMenuSelection}
            text="Locations"
            tooltip="View and manage your locations"
            icon={<MapPinIcon height={16} width={16} />}
          />
          {/* <MenuItem flag="brands" state={wifiMenuSelection} onClick={handleWifiMenuSelection} text="Brands" /> */}
          {userProfile?.user_role !== 'Manager' && (
            <MenuItem
            flag="team"
            state={wifiMenuSelection}
            onClick={handleWifiMenuSelection}
            text="Team"
            tooltip="View and manage your team members and their roles"
            icon={<UserGroupIcon height={16} width={16} />}
          />
          )}
          <MenuItem
            flag="details"
            state={wifiMenuSelection}
            onClick={handleWifiMenuSelection}
            text="Details"
            tooltip="View and manage your organisational details"
            icon={<BuildingOffice2Icon height={16} width={16} />}
          />
          {userProfile?.user_role !== 'Manager' && (
            <MenuItem
              flag="billing"
              state={wifiMenuSelection}
              onClick={handleWifiMenuSelection}
              text="Billing"
              tooltip="View and manage your subscriptions and billing information"
              icon={<CalendarDateRangeIcon height={16} width={16} />}
            />
          )}
        </Flex>
        <Flex style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start", height: "100%" }}>
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}
